import { render } from "./CLink.vue?vue&type=template&id=1bc0b99b&scoped=true"
import script from "./CLink.vue?vue&type=script&lang=js"
export * from "./CLink.vue?vue&type=script&lang=js"

import "./CLink.vue?vue&type=style&index=0&id=1bc0b99b&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc0b99b"]])

export default __exports__